"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavedAddressesProvider = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _utilities = require("../utilities");

var _initialState = require("./initialState");

var _Action = require("./Action");

var _SavedAddressesContext = require("./SavedAddressesContext");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var savedAddressesReducer = function savedAddressesReducer(state, action) {
  switch (action.type) {
    case _Action.SavedAddressesActions.SAVE_DELIVERY:
      (0, _utilities.setAddresses)((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        delivery: action.payload
      }));
      return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        delivery: action.payload
      });

    case _Action.SavedAddressesActions.SAVE_PICKUP:
      (0, _utilities.setAddresses)((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        pickup: action.payload
      }));
      return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        pickup: action.payload
      });

    default:
      throw new Error('Unsupported action type');
  }
};

var SavedAddressesProvider = function SavedAddressesProvider(props) {
  (0, _utilities.initializeAddresses)();
  var isSavedAddresses = (0, _utilities.getAddresses)();

  var _a = _react["default"].useReducer(savedAddressesReducer, isSavedAddresses || _initialState.initialState),
      state = _a[0],
      dispatch = _a[1];

  var value = _react["default"].useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state]);

  return _react["default"].createElement(_SavedAddressesContext.SavedAddressesContext.Provider, (0, _tslib.__assign)({
    value: value
  }, props));
};

exports.SavedAddressesProvider = SavedAddressesProvider;